import { usePunditUserContext } from "@circle-react/contexts/punditUserContext";
import { useSpaceNotificationsState } from "@circle-react/contexts/sidebarNotificationsContext";
import { isCommunityAdmin } from "@circle-react/helpers/communityMemberHelpers";
import { useSpaceLinkWithDefaultTab } from "@circle-react/helpers/spaceHelpers";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";

import { classNames } from "@/react/helpers/twMergeWithCN";
import { useLgScreenMediaQuery } from "@/react/hooks/useMediaQuery";

import type { SpaceViewProps } from "./SpaceView";
import { SpaceView } from "./SpaceView";

export interface SpaceProps {
  space: SpaceViewProps["space"];
}

const Space = ({ space }: SpaceProps) => {
  const getSpaceLinkWithDefaultTab = useSpaceLinkWithDefaultTab();
  const buttonLink = getSpaceLinkWithDefaultTab(space);

  const { currentCommunityMember } = usePunditUserContext();
  const isLgScreen = useLgScreenMediaQuery();
  const isAdmin = isCommunityAdmin(currentCommunityMember);
  const shouldDisableDragAndDropForSpaces = !isAdmin || !isLgScreen;

  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({
    id: `space-${space.id}`,
    disabled: shouldDisableDragAndDropForSpaces,
    data: {
      type: "space",
      id: space.id,
      spaceGroupId: space.space_group_id,
    },
  });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  const { spaces: spaceNotifications } = useSpaceNotificationsState();
  const spaceNotificationDetail = spaceNotifications.find(
    (spaceItem: any) => spaceItem.id === space.id,
  );

  return (
    <SpaceView
      ref={setNodeRef}
      style={style}
      {...attributes}
      {...listeners}
      space={space}
      buttonLink={buttonLink}
      spaceNotificationDetail={spaceNotificationDetail}
      className={classNames({
        "pointer-events-none opacity-50": isDragging,
      })}
    />
  );
};

export default Space;
